const subscriber_type = state => state.subscriber_type;
const subscribe_response = state => state.subscribe_response;
const transition_userid = state => state.transition_userid;
const transition_csmatno = state => state.transition_csmatno;
const transition_csorderno = state => state.transition_csorderno;
const transition_type = state => state.transition_type;

export {
    subscriber_type,
    subscribe_response,
    transition_userid,
    transition_csmatno,
    transition_csorderno,
    transition_type
}
